import { DefaultContext, EventObject, MachineConfig, StateSchema } from 'xstate/es';

import { UserSignInStatechartEvent } from 'common/module/user/sign-in/statechart.event';
import { UserSignInStatechartActionEnum } from 'common/module/user/sign-in/statechart/action.enum';
import { UserSignInStatechartStateEnum } from 'common/module/user/sign-in/statechart/state.enum';

export const UserSignInStatechart: MachineConfig<DefaultContext, StateSchema, EventObject> = {
  initial: UserSignInStatechartStateEnum.idle,
  on: {
    [UserSignInStatechartEvent.reset]: UserSignInStatechartStateEnum.idle,
  },
  states: {
    [UserSignInStatechartStateEnum.idle]: {
      on: {
        [UserSignInStatechartEvent.wantToSignIn]: UserSignInStatechartStateEnum.validating,
      },
    },
    [UserSignInStatechartStateEnum.validating]: {
      onEntry: [UserSignInStatechartActionEnum.validateInput],
      on: {
        [UserSignInStatechartEvent.inputIsValid]: UserSignInStatechartStateEnum.executingCaptcha,
        [UserSignInStatechartEvent.inputIsNotValid]: UserSignInStatechartStateEnum.idle,
      },
    },
    [UserSignInStatechartStateEnum.executingCaptcha]: {
      onEntry: [UserSignInStatechartActionEnum.showLoader, UserSignInStatechartActionEnum.executeCaptcha],
      on: {
        [UserSignInStatechartEvent.captchaValueChanged]: UserSignInStatechartStateEnum.signingIn,
      },
    },
    [UserSignInStatechartStateEnum.signingIn]: {
      onEntry: [UserSignInStatechartActionEnum.setRememberMe, UserSignInStatechartActionEnum.signIn],
      on: {
        [UserSignInStatechartEvent.signInFailed]: {
          target: UserSignInStatechartStateEnum.idle,
          actions: [UserSignInStatechartActionEnum.resetCaptchaToken],
        },
      },
    },
  },
};
